<template>
    <div class="home-professor">
        <c-panel title="Diário" titleIcon="fas fa-book-open">
            <p class="hp-ola">Olá, {{ primeiroNome }}. Escolha o que deseja lançar:</p>

            <div class="hp-cards" v-if="frequencia || nota">
                <router-link v-if="frequencia" to="/admin/diario/lancamento-frequencia" class="hp-card">
                    <i class="far fa-calendar-check"></i>
                    <span class="hp-titulo">Frequência</span>
                    <span class="hp-desc">Faltas, aulas compensadas e aulas dadas do bimestre</span>
                </router-link>
                <router-link v-if="nota" to="/admin/diario/lancamento-notas" class="hp-card">
                    <i class="far fa-edit"></i>
                    <span class="hp-titulo">Notas</span>
                    <span class="hp-desc">Média do bimestre das suas disciplinas</span>
                </router-link>
            </div>

            <el-alert v-else type="info" :closable="false" show-icon
                title="O lançamento de frequência e notas deste município é feito pelo Diário Eletrônico."></el-alert>
        </c-panel>
    </div>
</template>

<script>
// Home do professor (tipo 2) no web admin: só os atalhos de lançamento (spec_diario).
// A home da escola chama endpoints que o professor não tem permissão de usar.
export default {
    computed: {
        parametros () {
            return this.$store.state.config.parametros || {}
        },
        frequencia () {
            return this.parametros.frequencia_modo === 'periodo'
        },
        nota () {
            return this.parametros.nota_modo === 'media_periodo'
        },
        primeiroNome () {
            const nome = (this.$store.state.user && (this.$store.state.user.name || this.$store.state.user.nome)) || ''
            return nome.split(' ')[0]
        }
    }
}
</script>

<style>
    .home-professor .hp-ola {
        color: #606266;
        margin-bottom: 20px;
    }
    .home-professor .hp-cards {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    }
    .home-professor .hp-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 240px;
        min-height: 150px;
        padding: 20px;
        border: 2px solid #dcdfe6;
        border-radius: 12px;
        text-decoration: none;
        color: #303133;
        text-align: center;
        transition: border-color .2s, box-shadow .2s;
    }
    .home-professor .hp-card:hover {
        border-color: #1c69b3;
        box-shadow: 0 2px 10px rgba(28, 105, 179, .15);
    }
    .home-professor .hp-card i {
        font-size: 36px;
        color: #1c69b3;
        margin-bottom: 10px;
    }
    .home-professor .hp-titulo {
        font-size: 18px;
        font-weight: 600;
    }
    .home-professor .hp-desc {
        font-size: 12px;
        color: #909399;
        margin-top: 6px;
    }
</style>
